import api from './api';

export const financeiroService = {
  // Categorias
  listarCategorias: async (barbeariaId = null) => {
    const params = barbeariaId ? { barbeariaId } : {};
    const response = await api.get('/finance/categorias', { params });
    // api.get já retorna o JSON diretamente
    return response;
  },

  criarCategoria: async (data) => {
    const response = await api.post('/finance/categorias', data);
    // api.post já retorna o JSON diretamente
    return response;
  },

  atualizarCategoria: async (id, data) => {
    const response = await api.put(`/finance/categorias/${id}`, data);
    // api.put já retorna o JSON diretamente
    return response;
  },

  deletarCategoria: async (id) => {
    const response = await api.delete(`/finance/categorias/${id}`);
    // api.delete já retorna o JSON diretamente
    return response;
  },

  // Despesas
  listarDespesas: async (filtros = {}) => {
    const response = await api.get('/finance/despesas', { params: filtros });
    // api.get já retorna o JSON diretamente
    return response;
  },

  buscarDespesa: async (id) => {
    const response = await api.get(`/finance/despesas/${id}`);
    // api.get já retorna o JSON diretamente
    return response;
  },

  criarDespesa: async (data) => {
    const response = await api.post('/finance/despesas', data);
    // api.post já retorna o JSON diretamente
    return response;
  },

  atualizarDespesa: async (id, data) => {
    const response = await api.put(`/finance/despesas/${id}`, data);
    // api.put já retorna o JSON diretamente
    return response;
  },

  deletarDespesa: async (id) => {
    const response = await api.delete(`/finance/despesas/${id}`);
    // api.delete já retorna o JSON diretamente
    return response;
  },

  // Subdespesas
  criarSubDespesa: async (despesaId, data) => {
    const response = await api.post(`/finance/despesas/${despesaId}/sub`, data);
    // api.post já retorna o JSON diretamente
    return response;
  },

  atualizarSubDespesa: async (id, data) => {
    const response = await api.put(`/finance/subdespesas/${id}`, data);
    // api.put já retorna o JSON diretamente
    return response;
  },

  deletarSubDespesa: async (id) => {
    const response = await api.delete(`/finance/subdespesas/${id}`);
    // api.delete já retorna o JSON diretamente
    return response;
  },

  // Anexos
  uploadAnexo: async (despesaId, file) => {
    const formData = new FormData();
    formData.append('anexo', file);
    const response = await api.post(`/finance/despesas/${despesaId}/anexos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    // api.post já retorna o JSON diretamente
    return response;
  },

  deletarAnexo: async (id) => {
    const response = await api.delete(`/finance/anexos/${id}`);
    // api.delete já retorna o JSON diretamente
    return response;
  },

  // Dashboard
  dashboardResumo: async (filtros = {}) => {
    const response = await api.get('/finance/dashboard/resumo', { params: filtros });
    // api.get já retorna o JSON diretamente
    return response;
  },

  // DRE
  calcularDRE: async (filtros = {}) => {
    const response = await api.get('/finance/dre', { params: filtros });
    // api.get já retorna o JSON diretamente
    return response;
  },

  calcularDREConsolidado: async (filtros = {}) => {
    const response = await api.get('/finance/dre/consolidado', { params: filtros });
    // api.get já retorna o JSON diretamente
    return response;
  },

  // IA
  gerarInsights: async (mes, barbeariaId = null) => {
    const params = { mes };
    if (barbeariaId) params.barbeariaId = barbeariaId;
    const response = await api.get('/finance/ai/insights', { params });
    // api.get já retorna o JSON diretamente
    return response;
  },

  fazerPergunta: async (question, contexto = {}, barbeariaId = null) => {
    const data = { question, contexto };
    if (barbeariaId) data.barbeariaId = barbeariaId;
    const response = await api.post('/finance/ai/ask', data);
    // api.post já retorna o JSON diretamente
    return response;
  }
};

export default financeiroService;



